<div class="title">LOGIN TO YOUR ACCOUNT</div>
<div class="margin-top-48">
    <div>
        <span class="p-float-label">
            <input pInputText type="text" id="username" (keyup.enter)="login()" name="username" class="username"
                [(ngModel)]="form.username" />
            <label for="username">Email</label>
        </span>
        <span class="p-float-label margin-top-32">
            <input pInputText type="password" id="password" (keyup.enter)="login()" name="password" class="password"
                [(ngModel)]="form.password" />
            <label for="password">Password</label>
        </span>
        <div style="display: flex;">
            <a routerLink="/forgotpassword" class="forgotpassword">Forgot password?</a>
        </div>
        <div>
            <button type="submit" class="btn btn-primary" (click)="login()"
                [disabled]="loggingIn || (form.username.length===0 || form.password.length===0)"><i
                    class="fa fa-spin fa-spinner" *ngIf="loggingIn"></i><span *ngIf="!loggingIn">Login</span></button>
        </div>
    </div>
    <!-- <div class="margin-top-16">
        <div>
            <app-entra-login></app-entra-login>
        </div>
    </div> -->
    <div class="margin-top-16">
        <div>
            <app-trek-gigya-login></app-trek-gigya-login>
        </div>
    </div>
</div>
<div class="error" *ngIf="error">
    <span>{{errorMessage}}</span>
</div>